import DefaultLayout from "@/layouts/DefaultLayout";
import KNearMissReportForm from "kinnect-front/KSafety/NearMisses/KNearMissReportForm";
import { Crudable, FetchesData, Pageable } from "kinnect-mixins";
import { SafetyNearMissReport } from "kinnect-models";

export default {
	name: "SafetyNearMissReportPage",

	metaInfo() {
		const title = this.editing
			? "Safety - Near Miss Reports - Edit Report"
			: "Safety - Near Miss Reports - File a Report";

		return { title };
	},

	props: { idReport: Number },

	mixins: [
		Crudable,
		FetchesData,
		Pageable
	],

	data: () => ( {
		crud: "safety_near_miss_reports",
		report: null
	} ),

	computed: {
		editing() {
			return Boolean( this.idReport );
		}
	},

	methods: {
		async fetchReport() {
			if ( this.editing ) {
				this.report = await SafetyNearMissReport.findPageModel( this.idReport );
			}
		},

		async fetch() {
			await this.fetchReport();
		}
	},

	render() {
		return <DefaultLayout maxWidth="900px">
			<KNearMissReportForm
				loading={this.$wait.is( "find near miss report" )}
				readonly={this.editing ? !this.canEdit : !this.canAdd}
				report={this.report}
			></KNearMissReportForm>
		</DefaultLayout>;
	}
};
